// Import style
import './style.scss';

// Import animations
import { slideDown, slideUp } from '@automator/animations';

// Import utilities
import { onReady } from '@automator/utilities';

// Invoke classes when the DOM is ready
onReady( () => {
	new Accordions();
} );

export default class Accordions {
	constructor() {
		// Create accordions
		this.createAccordions();
	}

	createAccordions() {
		// Iterate accordions on the DOM
		[ ...this.$accordions ].forEach( ( $accordion ) => {
			// Create accordions
			new Accordion( $accordion );
		} );
	}

	get $accordions() {
		return document.querySelectorAll( '.uap-accordion' );
	}
}

class Accordion {
	constructor( $accordion ) {
		// Save the accordion element
		this.$accordion = $accordion;

		// Listen clicks to the toggles
		this.listenClicksToToggles();
	}

	listenClicksToToggles() {
		// Iterate toggles
		[ ...this.$toggles ].forEach( ( $toggle ) => {
			// Listen clicks to the toggle
			$toggle.addEventListener( 'click', ( event ) => {
				// Get parent element
				const $item = $toggle.closest( `.${this.cssSelectors.itemClass}` );

				// Toggle item
				this.toggleItem( $item );
			} );
		} );
	}

	toggleItem( $item ) {
		// Get the item elements
		const $itemElements = {
			toggle: $item.querySelector( `.${this.cssSelectors.itemToggleClass}` ),
			content: $item.querySelector( `.${this.cssSelectors.itemContentClass}` ),
		};

		// Check if the item is opened
		if ( $item.classList.contains( this.cssSelectors.itemOpenClass ) ) {
			// Close it
			slideUp( $itemElements.content, {
				duration: 300,
				onComplete: () => {
					// Remove the "open" class from the item
					$item.classList.remove( this.cssSelectors.itemOpenClass );
				},
			} );
		} else {
			// Open it

			// Add the "open" class
			$item.classList.add( this.cssSelectors.itemOpenClass );

			slideDown( $itemElements.content, {
				duration: 300,
			} );
		}
	}

	get $toggles() {
		return this.$accordion.querySelectorAll( `.${this.cssSelectors.itemToggleClass}` );
	}

	get cssSelectors() {
		return {
			itemClass: 'uap-accordion-item',
			itemOpenClass: 'uap-accordion-item--open',
			itemToggleClass: 'uap-accordion-item__toggle',
			itemContentClass: 'uap-accordion-item__content',
		};
	}
}
